module.exports = __webpack_public_path__ + "img/Isotipo_Negativo.c4add9c1.png";